<template>
  <div class="px-gen py-2 web-service mx-0">
    <h3 class="ui dividing header fdinpro is-uppercase">
      {{ $t("active systems") }}
    </h3>
    <p class="is-capitalized" v-for="(store, index) in stores" :key="index">
      <i
        class="circle icon web-service-icon"
        v-bind:class="{ active: store.setup.is_api_active }"
      ></i>
      {{ $t("webService") }} (API) [{{ store.setup.name }}]
    </p>
    <!--Agregar la clase "active" a <i> para volver el icono verde-->
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "NvidiaTicketStoreSystemMonitor",
  data() {
    return {
      is_web_service_enabled: false,
      stores: [],
    };
  },
  props: {},
  mounted() {},
  methods: {
    setStores(stores) {
      let vm = this;
      local_api(vm, "post", "/nworkforce_store/do-get-services", {
        stores: stores.map((s) => {
          return s.store_id;
        }),
      })
        .then(function(r) {
          vm.stores = r;
          // if (r && r.length > 0) {
          //   vm.is_web_service_enabled = r.reduce((prev, curr) => {
          //     return prev && curr.setup.is_api_active;
          //   }, true);
          // }
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
  },
};
</script>

<style scoped>
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
} /*gen controla padding de los 3 modulos principales*/
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.web-service {
  background-color: #fbfaf6 !important;
  /* width: 100% !important; */
  position: fixed;
  bottom: 0px;
}
.web-service-icon {
  color: red;
  padding-right: 2rem !important;
}
.web-service-icon.active {
  color: greenyellow;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.is-capitalized {
  text-transform: capitalize !important;
}
</style>
